const utils = require('frontend-controller/lib/utils');

module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'form'
	],

	methods: {
		submit: function(){
			var self = this;

			var contactEnvironment = {};
			self.closest('layouts_gridNavigator_gridNavigator', function(gridComponent){
				contactEnvironment.route = gridComponent.model.activeRoute || '';
				contactEnvironment.routeID = gridComponent.model.activeRouteID || '';
				contactEnvironment.contact = ((gridComponent.model.master || {}).model.routeConfig || {}).contact || {};
			});

			// check if at least one child has to block the submit
			return self.prepareChildrenForSubmit().then(function(context){
				var dirties = self.getDirties();

				// give all forms the chance to react on submit event and validate forms
				var validationResult = {};
				self.onBeforeSubmit(true, dirties, validationResult);

				// check if validation error occured
				if(!validationResult.invalid){
					if(self.model.preventSubmit){
						return utils.promise.reject('preventSubmit');
					}

					// call handler for other components
					self.callHandler('beforeSubmit');
					var data = utils.copy(self.model.dirtyFields);
					if((data || {}).data){
						data.data.contactEnvironment = contactEnvironment;
					}

					$.ajax({
						url: '/_/contactMail',
						method: 'POST',
						data: JSON.stringify(data)
					}).then(function(context){
						self.model.dirtyFields = {};
						$('body > .templates_headPanel_sidePanels_contactFormSuccess, body > .templates_headPanel_sidePanels_contactFormError').removeClass('active show');
						self.closest('templates_headPanel_headPanel', function(headPanel){
							headPanel.hide();
						});
						var $successMessage = $('body > .templates_headPanel_sidePanels_contactFormSuccess').addClass('show')
						setTimeout(function($element){
							$element.addClass('active');
						}, 100, $successMessage);
						setTimeout(function($element){
							$element.removeClass('active');
						}, 2600, $successMessage);
						setTimeout(function($element){
							$element.removeClass('show');
							self.refresh();
						}, 3100, $successMessage);

					}).fail(function(error){
						$('body > .templates_headPanel_sidePanels_contactFormSuccess, body > .templates_headPanel_sidePanels_contactFormError').removeClass('active show');
						self.closest('templates_headPanel_headPanel', function(headPanel){
							headPanel.hide();
						});
						var $successMessage = $('body > .templates_headPanel_sidePanels_contactFormError').addClass('show')
						setTimeout(function($element){
							$element.addClass('active');
						}, 100, $successMessage);
						setTimeout(function($element){
							$element.removeClass('active');
						}, 5600, $successMessage);
						setTimeout(function($element){
							$element.removeClass('show');
						}, 6100, $successMessage);
					});
				}
			});
		}
	}
};